module.exports = __webpack_public_path__ + "img/poc-splash.fe1d1958.svg";